"use strict";
"use client";
'use strict';

var factory = require('../../styled-system/factory.cjs');

const Span = factory.chakra("span");

exports.Span = Span;
